<template>
    <div :class="[gridColumns, hasBanner ? '-mt-8 pt-8 tablet:pt-0': '']">

        <!-- Cards -->
        <div
            class="flex flex-col gap-4 items-stretch h-full bg-white shadow-card rounded-md relative p-4"
            :class="hasBanner ? hasBanner + ' overflow-hidden': ''">
            <span v-if="hasBanner"
                class="text-navy-dark text-center font-bold absolute top-0 -left-1.5 py-2 rounded-t"
                :class="hasBanner.indexOf('teal') > -1? 'bg-teal': 'bg-salmon'"
                style="width: 102.5%">
                    Limited Time Offer
            </span>

            <!-- Speed -->

            <div v-if="type === 'internet'"
                class="flex justify-between border-b border-gray-200 pb-4"
                :class="hasBanner ? 'pt-8': ''">
                <div>
                    <BusinessInternetSpeedGauge
                        :speed="speed.download" />
                </div>
                <div
                    class="font-bold tablet:ml-0 text-left tablet:text-center text-sm text-navy-dark"
                >
                    <div class="text-2lg">
                        {{ speed.download }} Mbps
                    </div>
                    <div class="text-sm">
                        {{ speed.upload }} Mbps Upload
                    </div>
                </div>
            </div>

            <!-- Pricing -->

            <div
                class="flex flex-col items-center justify-between border-b border-gray-200 pb-4 gap-2">
                <div class="text-center">
                    <span class="text-navy-dark font-bold">{{ name }}</span>
                    <span class="block text-sm">{{ packageDetails }}</span>
                </div>
                <div v-if="displayPrice"
                    class="flex justify-center w-full "
                    :class="type == 'internet-tv' ? 'border-t border-gray-200 pt-4' : ''"
                    >
                    <BusinessPricePerMonth
                        :price="monthlyCharge"
                        :unit="unit"
                    />
                    <button
                        @click.prevent="setTerms(termDisclaimer)"
                        class="text-blue-light flex"
                    >
                        <IconCircleInfo class="inline" />
                    </button>
                </div>
            </div>

            <!-- Promos -->

            <div v-if="promotions" class="pb-3 border-solid border-b border-gray-200 ">
                <div class="text-navy-dark bg-blue-lightest rounded-md text-sm font-heavy text-center flex justify-center items-center gap-2 p-4">
                    <img src="/assets/icons/positive_resi_icon.png" class="w-5 h-5" alt="Plus Symbol">
                    <p v-html="promotions" class="uppercase text-left"></p>
                </div>
            </div>

            <!-- Details -->
            <div
                class="col-span-full text-navy-dark desktop:mb-6">
                <ul
                    v-if="details && type === 'internet'"
                    class="list-disc w-64 m-auto list-outside text-sm font-bold"
                >
                    Fast enough for:
                    <li
                        v-for="(detail, index) in details.content"
                        :key="index"
                        class="mt-2 ml-2 text-xs tablet:text-sm font-normal"
                    >
                        {{ detail }}
                    </li>
                </ul>
                <ul v-else-if="details && type === 'internet-voice'"
                    class="w-64 m-auto list-disc list-outside text-sm font-bold">
                    Key Features:
                    <li
                        v-for="(detail, index) in details.content"
                        :key="index"
                        class="mt-2 ml-2 text-xs tablet:text-sm font-normal"
                    >
                        {{ detail }}
                    </li>
                    <li v-if="details.label !== 'Internet + Standard Voice'"
                        class="list-none font-normal mt-6">
                        Need more for your business? Check out <a href="/business/enterprise/hosted-voice" class="font-bold underline text-navy-dark hover:text-blue">Hosted Voice Essential Support</a>
                    </li>
                    <li v-else
                        class="list-none font-normal mt-6">
                        Need more for your business? Check out <a href="/business/voice-service" class="font-bold underline text-navy-dark hover:text-blue">Standard Voice Support</a>
                    </li>
                </ul>
                <ul v-else-if="details && type === 'internet-tv'"
                    class="w-64 m-auto list-disc list-outside text-sm font-bold">
                    Includes:
                    <li
                        v-for="(detail, index) in details.content"
                        :key="index"
                        class="mt-2 ml-2 text-xs tablet:text-sm font-normal"
                    >
                        {{ detail }}
                    </li>
                    <!-- <li class="list-none mt-6">
                         <a href="/business/enterprise/hosted-voice" class="font-bold text-navy-dark underline hover:text-blue">View channel lineup</a>
                    </li> -->
                </ul>
            </div>

            <!-- CTA -->
            <div class="mt-auto">
                <a
                    v-if="offerLinkUrl"
                    :href="offerLinkUrl"
                    class="block text-sm text-navy-dark underline font-bold pb-4">
                        {{ offerLinkLabel }}
                </a>
                <button
                    v-if="webForm"
                    type="button"
                    class="track btn-secondary-sm mt-3"
                    @click.prevent="$emit('on-click')"
                    data-category="biz: start now"
                    :data-label="`biz: ${ name.toLowerCase() }`"
                    :data-action="`biz: ${ pageSlug } page`">
                    {{ ctaText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"
import BusinessPricePerMonth from "@/atoms/BusinessPricePerMonth"
import BusinessInternetSpeedGauge from "@/atoms/BusinessInternetSpeedGauge"
import IconCircleInfo from "@/atoms/icons/IconCircleInfo"
import ohio_array from './zips/ohio.js'

export default {
    name: "BusinessOfferCard",
    components: {
        BusinessPricePerMonth,
        BusinessInternetSpeedGauge,
        IconCircleInfo,
    },
    props: {
        isAutopay: {
            type: Boolean,
            required: false,
            default: false,
        },
        monthlyCharge: {
            type: Number,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        speed: {
            type: Object,
            required: true,
        },
        details: {
            type: Object,
            required: false,
        },
        terms: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        mostPopular: {
            type: Boolean,
            required: false,
            default: false,
        },
        mostPopularText: {
            type: String,
            required: false,
            default: null,
        },
        hasBanner: {
            type: String,
            required: false,
        },
        ctaText: {
            type: String,
            required: false,
        },
        offerLinkLabel: {
            type: String,
            required: false,
        },
        offerLinkUrl: {
            type: String,
            required: false,
        },
        promotions: {
            type: String,
            required: false,
        },
        termDisclaimer: {
            type: String,
            required: false,
        },
        displayPrice: {
            type: Boolean,
            default: true,
            required: false,
        },
        layout: {
            type: String,
            default: 'stacked',
            validator: (val) => ['stacked', 'card'].includes(val),
        },
        webForm: {
            required: false,
        },
    },
    data: () => ({
        detailsExpanded: false,
        postalCode: null,
        channelLineUpsLink: null,
    }),
    computed: {
        ...mapState([
            'meta'
        ]),
        term() {
            if (this.type === "internet") {
                const internet = this.terms.find(
                    (element) => element.type === "HSD Only"
                );
                return internet.name;
            } else if (this.type === "internet-voice") {
                const voice = this.terms.find(
                    (element) => element.type === "HSD + Voice"
                );
                return voice.name;
            } else if (this.type === "internet-tv") {
                const tv = this.terms.find(
                    (element) => element.type === "HSD + TV"
                );
                return tv.name;
            }
        },
        internetTerms() {
            if (this.term === "For 2 years") {
                return "for 2 years w/ a 3-year contract";
            } else if (this.term === "Requires subscription" || this.term == "Per line") {
                return "Requires subscription to Breezeline Business Internet service";
            } else {
                return "For 3 years with autopay discount";
            }
        },
        gridColumns() {
            const classes = []

            if (this.layout === "card") {
                classes.push('flex flex-col w-screen max-w-full desktop:max-w-xs')
            } else {
                classes.push('col-span-full')
            }

            return classes.join(' ')
        },
        packageDetails() {
            if (this.type === 'internet-voice') {
                return 'Price per line'
            } else if (this.type === 'internet-tv') {
                return this.details.channel_count + '+ Channels'
            } else {
                return 'Unlimited data'
            }
        },
        pageSlug() {
            const { pathname } = window.location;
            const paths = pathname.split("/").filter(entry => entry !== "");
            const slug = paths[paths.length - 1];

            if (slug === 'internet-packages') {
                return 'internet'
            } else if (slug === 'voice-service') {
                return 'voice'
            }
            return slug;
        },
        unit() {
            return this.type === 'internet-voice' ? '' : 'each'
        },
        // displayChannelLineUpsLink() {
        //      if (this.type == 'internet-tv' && ohio_array.includes(this.meta.postalCode)) {
        //         return this.channelLineUpsLink = 'View Channel Lineup'
        //      }
        // }
    },
    created() {
        const handleEscape = (e) => {
            if (e.key === "Esc" || e.key === "Escape") {
                this.detailsExpanded = false;
            }
        };
        document.addEventListener("keydown", handleEscape);
        this.$once("hook:beforeDestroy", () => {
            document.removeEventListener("keydown", handleEscape);
        });
    },
    methods: {
        toggleDetails() {
            this.detailsExpanded = !this.detailsExpanded;
        },
        setTerms(terms) {
            this.$emit("term-click", terms);
        },
        convertStringToArray(string) {
            return string.split(",");
        },

    },
};
</script>
